import * as ambassadorWixStoresV1AbandonedCart from './stores-v1-abandoned-cart-abandoned-carts.http.js';
import * as ambassadorWixStoresV1AbandonedCartTypes from './stores-v1-abandoned-cart-abandoned-carts.types.js';
import * as ambassadorWixStoresV1AbandonedCartUniversalTypes from './stores-v1-abandoned-cart-abandoned-carts.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getAbandonedCart(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixStoresV1AbandonedCartUniversalTypes.GetAbandonedCartRequest,
  ambassadorWixStoresV1AbandonedCartTypes.GetAbandonedCartRequest,
  ambassadorWixStoresV1AbandonedCartUniversalTypes.GetAbandonedCartResponse,
  ambassadorWixStoresV1AbandonedCartTypes.GetAbandonedCartResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixStoresV1AbandonedCart.getAbandonedCart(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/abandonedCarts/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryAbandonedCarts(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixStoresV1AbandonedCartUniversalTypes.QueryAbandonedCartsRequest,
  ambassadorWixStoresV1AbandonedCartTypes.QueryAbandonedCartsRequest,
  ambassadorWixStoresV1AbandonedCartUniversalTypes.QueryAbandonedCartsResponse,
  ambassadorWixStoresV1AbandonedCartTypes.QueryAbandonedCartsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixStoresV1AbandonedCart.queryAbandonedCarts(payload);

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/abandonedCarts/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  AbandonedCart as AbandonedCartOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  BuyerInfo as BuyerInfoOriginal,
  Identity as IdentityOriginal,
  IdentityWithLiterals as IdentityWithLiteralsOriginal,
  Activity as ActivityOriginal,
  ActivityType as ActivityTypeOriginal,
  ActivityTypeWithLiterals as ActivityTypeWithLiteralsOriginal,
  CustomData as CustomDataOriginal,
  CartAbandonedEvent as CartAbandonedEventOriginal,
  Totals as TotalsOriginal,
  CartRecoveredEvent as CartRecoveredEventOriginal,
  CartDeletedEvent as CartDeletedEventOriginal,
  GetAbandonedCartRequest as GetAbandonedCartRequestOriginal,
  GetAbandonedCartResponse as GetAbandonedCartResponseOriginal,
  QueryAbandonedCartsRequest as QueryAbandonedCartsRequestOriginal,
  Query as QueryOriginal,
  Paging as PagingOriginal,
  QueryAbandonedCartsResponse as QueryAbandonedCartsResponseOriginal,
  DeleteCartRequest as DeleteCartRequestOriginal,
  DeleteCartResponse as DeleteCartResponseOriginal,
  RedirectToCheckoutRequest as RedirectToCheckoutRequestOriginal,
  RawHttpResponse as RawHttpResponseOriginal,
  HeadersEntry as HeadersEntryOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
} from './stores-v1-abandoned-cart-abandoned-carts.types.js';
